import settings from './settings/settings.routes';
import conversation from './conversation/conversation.routes';
import { routes as searchRoutes } from '../../modules/search/search.routes';
import { routes as contactRoutes } from './contacts/routes';
import { routes as companyRoutes } from './companies/routes';
import { routes as notificationRoutes } from './notifications/routes';
import { routes as inboxRoutes } from './inbox/routes';
import { frontendURL } from '../../helper/URLHelper';
import helpcenterRoutes from './helpcenter/helpcenter.routes';
import campaignsRoutes from './campaigns/campaigns.routes';
import { routes as captainRoutes } from './captain/captain.routes';
import { routes as ardhisasaTicketRoutes } from './tickets/routes';
import { routes as ardhisasaUserRoutes } from './users/routes';
import { routes as ardhisasaLandRecordsRoutes } from './landrecords/routes';
import { routes as ardhisasaLandProcessesRoutes } from './landprocesses/routes';
import AppContainer from './Dashboard.vue';
import Suspended from './suspended/Index.vue';
import ArdhisasaPasswordSync from './ardhisasaPasswordSync/Index.vue';
import NoAccounts from './noAccounts/Index.vue';
import OnboardingAccountDetails from './onboarding/Index.vue';

export default {
  routes: [
    {
      path: frontendURL('accounts/:accountId'),
      component: AppContainer,
      children: [
        ...captainRoutes,
        ...inboxRoutes,
        ...conversation.routes,
        ...settings.routes,
        ...contactRoutes,
        ...companyRoutes,
        ...searchRoutes,
        ...notificationRoutes,
        ...helpcenterRoutes.routes,
        ...campaignsRoutes.routes,
        ...ardhisasaTicketRoutes,
        ...ardhisasaUserRoutes,
        ...ardhisasaLandRecordsRoutes,
        ...ardhisasaLandProcessesRoutes,
      ],
    },
    {
      path: frontendURL('accounts/:accountId/onboarding'),
      name: 'onboarding_account_details',
      meta: {
        permissions: ['administrator', 'agent', 'custom_role'],
      },
      component: OnboardingAccountDetails,
    },
    {
      path: frontendURL('accounts/:accountId/suspended'),
      name: 'account_suspended',
      meta: {
        permissions: ['administrator', 'agent', 'custom_role'],
      },
      component: Suspended,
    },
    {
      path: frontendURL('accounts/:accountId/ardhisasa-password-sync'),
      name: 'ardhisasa_password_sync',
      meta: {
        permissions: ['administrator', 'agent', 'custom_role'],
      },
      component: ArdhisasaPasswordSync,
    },
    {
      path: frontendURL('no-accounts'),
      name: 'no_accounts',
      component: NoAccounts,
    },
  ],
};
